<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <div class="p-3">
            <Gallery :images="imagesForGallery" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col md:flex-row pt-12 md:pt-24 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Rastenberger Orgelpfeifen</h1>
                    <p class="text-lg text-gray-500 mt-3">Pfadfinder</p>
                    <div class="flex sm:flex-row flex-col items-start gap-4 sm:items-center p-3 shadow-md rounded-md mt-5 max-w-[550px] bg-white">
                        <img src="/assets/themenwelt/pfadfinder/orgelpfeifen_logo.webp" class="w-40">
                        <p class="text-sm"><span class="font-bold text-base">Logo der Rastenberg
                                Orgelpfeifen</span><br><br>Nach langen Gesprächen und der Anfertigung zahlreicher
                            Entwürfe und
                            ist es schließlich fertig, unser neues Wappen! Mit besonderen Dank an <span
                                class="font-bold">Martina Müller</span> und <span class="font-bold">Frank Koch</span>.
                        </p>
                    </div>
                    <p class="mt-5 max-w-lg lg:max-w-xl">Die Rastenberger Orgelpfeifen agieren als freie
                        Pfadfindergruppe der Kirchengemeinde Rastenberg. Haben Sie oder ihr Kind Interesse mit zum
                        machen? Dann melde Sie sich doch gern bei uns.</p>
                </div>

                <div>
                    <h2 class="font-written text-4xl">Unternehmungen</h2>
                    <p class="text-lg text-gray-500 mt-3">Was wir bisher getan haben.</p>
                    <div class="mt-5 max-w-lg lg:max-w-xl">
                        <div class="flex gap-2 mt-2" v-for="i in points" :key="i">
                            <svg class="w-5 h-5 shrink-0 text-primary-default" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="m10 16 4-4-4-4" />
                            </svg>
                            <p>{{ i }}</p>
                        </div>
                    </div>
                </div>

                <div>
                    <h2 class="font-written text-4xl">Stammesgründung gelungen!</h2>
                    <p class="text-lg text-gray-500 mt-3">Roldisleben</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">Vom 18. - 20. August 2017 fand unser Camp zur Stammesgründung
                        der
                        Rastenberger Orgelpfeifen in Roldisleben statt. Ein großer Dank gilt Familie Bismark, die ihren
                        wunderschönen Garten für unsere Zelte zur Verfügung stellten. Es wurde Quiddich gespielt, Feuer
                        gemacht, gesungen. Wir lernten von Herrn Bismark vieles über einheimische und fremdländische
                        Baumarten. Zudem besuchten wir die beeindruckende und preisgekrönte Schweine-Mastanlage der
                        Firma Weillepp aus Roldisleben. Die Krönung dann am Sonntag der Festgottesdienst zur feierlichen
                        Stammesgründung unter Anwesenheit von Vertretern des Landesverbands des VCP Mitteldeutschland.
                        Es war toll! Insgesamt nahmen 30 Kinder an dem Wochenende teil. Sechzehn aktive Mitglieder zählt
                        der Stamm momentan.</p>
                </div>

                <div>
                    <h2 class="font-written text-4xl">Neue Regeln</h2>
                    <p class="text-lg text-gray-500 mt-3">Stammessatzung</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Am 09. März 2017 trafen sich die Orgelpfeifen wieder in Rastenberg. In einer einstündigen intensiven
                        Arbeitseinheit beschäftigten sich die Pfadfinder mit ihrer Stammessatzung. In einer
                        vorausgehenden Sitzung wählten die Kinder einen Vorsitzenden, sowie einen 1. und 2. Vorsitzenden
                        des Stammes, daneben einen Ordnungsbeauftragten, einen Streitschlichter, einen Kassenwart und
                        einen Ideensammler. Diese Ämter werden künftig jährlich bei der ordentlichen Stammesversammlung
                        neu gewählt. Allen Ämtern ist ei Erwachsener Berater zur Seite gestellt. Das ist Basisdemokratie
                        bei den Rastenberger Orgelpfeifen!
                        <br>
                        <br>
                        Die Pfadis in vollem Einsatz, beim Bau einer selbsttragenden Brücke. Diese noch etwas wackelige
                        Konstruktion überwindet immerhin bereits einen kleinen Teppich.
                        Im Februar beschloss die Pfadfindergruppe mit übergroßer Mehrheit basisdemokratisch ihren
                        Stammesnamen:
                        <span class="font-bold">"Rastenberger Orgelpfeifen"</span>.
                    </p>
                </div>
            </div>
            <GridNav />
        </div>
    </div>
</template>

<script>
import GridNav from "@/components/gridNav.vue";
import Gallery from "@/components/gallery.vue";

export default {
    name: 'Pfadfinder',
    data() {
        return {
            points: [
                "Bäume pflanzen in Roldisleben",
                "Teilnahme am Badewannenwettrennen im Waldschwimmbad Rastenberg",
                "Hüttenbau im Wald",
                "Schnitzübungen im Rastenberger Wald",
                "Besuch der Kleingartenanlage 'Schmelzhütte' in Rastenberg mit Führung",
                "Wanderungen",
                "Arbeitseinsatz an der Kirche",
                "Sammeln und Beräumen von Unrat in Wald und Flur, Teilnahme am Frühjahrsputz in Rastenberg 2018",
                "Errichtung eines kleines Dorfes in der Drachenschlucht bei Laucha an der Unstrut",
                "Adventssingen in Rastenberg",
                "Plätzchenverkauf auf dem Weihnachtsmarkt in Rastenberg",
                "Brückenbau über die Lossa im Pfarrgarten",
                "Pfadi-Camp zur Stammesgründung in Roldisleben",
                "Kinder-Wald-Wochenende 2016"
            ],
            imagesForGallery: [
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-8.webp",
                    alt: "Pfadfinder 8",
                    objectCover: true
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-1.webp",
                    alt: "Pfadfinder 1"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-2.webp",
                    alt: "Pfadfinder 2"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-3.webp",
                    alt: "Pfadfinder 3"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-4.webp",
                    alt: "Pfadfinder 4"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-5.webp",
                    alt: "Pfadfinder 5"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-6.webp",
                    alt: "Pfadfinder 6"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-7.webp",
                    alt: "Pfadfinder 7"
                },
                {
                    url: "/assets/themenwelt/pfadfinder/pfadfinder-9.webp",
                    alt: "Pfadfinder 9"
                },
            ]
        }
    },
    components: {
        GridNav,
        Gallery
    }
}
</script>